module.exports = __webpack_public_path__ + "static/media/hide-idle.0fb959b1.svg";